import React, { Component } from "react";
import Navigation from "./shared/components/navigation";
import Reports from "./pages/reports";
import Header from "./pages/header";
import About from "./pages/about";
import Team from "./pages/team";

export class App extends Component {
	render() {
		return (
			<div>
				<Header />
				<About />
				<Team />
				<Reports/>
			</div>
		);
	}
}

export default App;
